export const nav = {
    permissao: 'hdocs.emissao:previsualizar',
    section: 'Documentos',
    title: 'Emissao',
    icon: 'post_add',
    route: '/emissao',
    sequence: 1,
};

export default [
    {
        path: '/emissao',
        name: 'emissao',
        component: () => import('./pages/EmissaoPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.emissao:previsualizar' },
    },
];
